export const FLIGHT_RESERVE_UNTIL_TIME = [
    { id: 1, name: " یک ساعت قبل پرواز" },
    { id: 2, name: " دو ساعت قبل پرواز" },
    { id: 3, name: " سه ساعت قبل پرواز" },
    { id: 4, name: " چهار ساعت قبل پرواز" },
    { id: 5, name: " پنج ساعت قبل پرواز" },
    { id: 6, name: " شش ساعت قبل پرواز" },
    { id: 7, name: " هفت ساعت قبل پرواز" },
    { id: 8, name: " هشت ساعت قبل پرواز" },
    { id: 9, name: " نه ساعت قبل پرواز" },
    { id: 10, name: " ده ساعت قبل پرواز" },
];
